export const RESET_ORDER_ISFETCHING = 'RESET_ORDER_ISFETCHING';
export const GET_ORDER_REQUEST = 'GET_ORDER_REQUEST';
export const GET_ORDER_BY_EMAIL_ORDERNUMBER_REQUEST =
  'GET_ORDER_BY_EMAIL_ORDERNUMBER_REQUEST';
export const GET_ORDER_REQUESTING = 'GET_ORDER_REQUESTING';
export const GET_ORDER_SUCCESS = 'GET_ORDER_SUCCESS';
export const LIST_ORDERS_REQUEST = 'LIST_ORDERS_REQUEST';
export const ORDER_REQUESTING = 'ORDER_REQUESTING';
export const LIST_ORDERS_SUCCESS = 'LIST_ORDERS_SUCCESS';
export const RESET_ORDER_QUERY = 'RESET_ORDER_QUERY';
